import styled from 'styled-components';
import RedScreenLayout from '../components/RedScreenLayout';
import { APP_STORE_SMART_LINK } from '../constants';

const Heading = styled.h1`
  font-family: 'Speedee Bold';
  font-size: 32px;
  line-height: 1.1;
  color: #ffffff;
  text-align: center;
  margin: 32px 24px 16px;
`;

const SubText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  text-align: center;
  margin: 0 24px 24px;
`;

const ClaimButton = styled.button`
  width: calc(100% - 32px);
  max-width: 360px;
  background: #ffbc0d;
  border: none;
  border-radius: 8px;
  padding: 18px 32px;
  font-family: 'Speedee Bold';
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
  color: #2d2d2d;
  text-align: center;
  cursor: pointer;
  line-height: 1;
`;

function CampaignEnded() {
  return (
    <RedScreenLayout>
      <Heading>This campaign has now wrapped up!</Heading>

      <SubText>Thanks for being part of it. Stay tuned for more deals coming soon and check the MyMacca's app for other great offers.</SubText>

      <ClaimButton
        onClick={() => {
          window.open(APP_STORE_SMART_LINK, '_blank');
          window.gtag('event', 'mm-end-mymaccas');
        }}>
        GO TO MYMACCA'S APP
      </ClaimButton>
    </RedScreenLayout>
  );
}

export default CampaignEnded;
